import { render, staticRenderFns } from "./CaregiverForm.vue?vue&type=template&id=dd60b6ae&scoped=true"
import script from "./CaregiverForm.vue?vue&type=script&lang=js"
export * from "./CaregiverForm.vue?vue&type=script&lang=js"
import style0 from "./CaregiverForm.vue?vue&type=style&index=0&id=dd60b6ae&prod&lang=scss&scoped=true"
import style1 from "./CaregiverForm.vue?vue&type=style&index=1&id=dd60b6ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd60b6ae",
  null
  
)

export default component.exports